// Prevent scroll...
import { stopBodyScroll, allowBodyScroll } from '../controls/controlBodyScroll'

// A class to handle the opening of dialogs by clicking remotely.
class ShowDialog {
  constructor (elem) {
    this.elem = elem
    this.id = this.elem.dataset.dialogOpen
    this.dialog = document.getElementById(this.id)
    this.elem.addEventListener('click', (e) => {
      this.open()
    })
  }

  open () {
    if (this.dialog) {
      stopBodyScroll()
      this.dialog.showModal()
    }
  }
}

// A class to handle the closing of dialogs by clicking remotely.
class CloseDialog {
  constructor (elem) {
    this.elem = elem
    this.id = this.elem.dataset.dialogClose
    this.dialog = document.getElementById(this.id)
    this.elem.addEventListener('click', (e) => {
      this.close()
    })
  }

  close () {
    if (this.dialog) {
      allowBodyScroll()
      this.dialog.close()
    }
  }
}

export function loadDialogOpeners () {
  const elems = document.querySelectorAll('[data-dialog-open]')
  const dialogOpeners = []

  for (const element of elems) {
    dialogOpeners.push(new ShowDialog(element))
  }

  const closers = document.querySelectorAll('[data-dialog-close]')
  const dialogClosers = []

  for (const celement of closers) {
    dialogClosers.push(new CloseDialog(celement))
  }

  return dialogOpeners
}
